<fieldset [formGroup]="skjema()">

  <moete-rediger-tidspunkt [skjema]="skjema().controls.tidspunkt" [fokuserStartdatoFelt]="fokuserStartdatoFelt()"></moete-rediger-tidspunkt>

  <div class="sted-og-måte">
    <mat-form-field>
      <mat-label>{{ "Møtested"|translate }}</mat-label>
      <mat-icon matPrefix fontSet="ion-ios-location-outline" class="mat-icon--ionic-ikon"/>
      <input matInput formControlName="moetested" data-testid="behandlingsSted">
      @if(skjema().controls.moetested.hasError('maxlength')){
        <mat-error data-testid="maxlength">{{skjema().controls.moetested.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
      }
      <mat-hint>{{ "F.eks lenke til digitalt møte, adresse"|translate }}</mat-hint>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "Behandlingsmåte"|translate }}</mat-label>
      <mat-icon matPrefix fontSet="ion-ios-home-outline" class="mat-icon--ionic-ikon"/>
      <input matInput formControlName="behandlingsmaate" [matAutocomplete]="auto" data-testid="behandlingsMåte">
      <mat-autocomplete #auto="matAutocomplete">
        @for (alternativ of stdBehandlingsmaater; track alternativ) {
          <mat-option [value]="alternativ">{{ alternativ }}</mat-option>
        }
      </mat-autocomplete>
      @if(skjema().controls.behandlingsmaate.hasError('maxlength')){
        <mat-error data-testid="maxlength">{{skjema().controls.behandlingsmaate.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
      }
    </mat-form-field>
  </div>

  <mat-form-field class="formål">
    <mat-label>{{ "Formål"|translate }}</mat-label>
    <riktekst-redigering [skjemakontroll]="skjema().controls.formaal" [gruppeId]="gruppeId()" data-testid="formaal"/>
    <mat-hint>{{ "Hva er hovedformålet med møtet? Hjelp deltakere å fokusere for å sikre sluttresultat"|translate }}</mat-hint>
  </mat-form-field>

</fieldset>
